import Loading from '../../../Loading/Loading';
import Show from '../../../Show/Show';
import { AnswerSelectPresentationProps } from '../config';
import { FC } from 'react';
import { SPACING } from '../../../../config/designSystem/Spacing';
import { ScrollView, StyleSheet } from 'react-native';
import { TherapistCard } from '../../../Assistance/TherapistCard/TherapistCard';
import { getMetaValue } from '../../utils';
import { observer } from 'mobx-react';
import { useStores } from '../../../../hooks/useStores';

const _PresentCounsellors: FC<AnswerSelectPresentationProps> = ({
  answers,
  questionId,
  onPress,
}) => {

  const { question: qstore } = useStores();

  return (
    <ScrollView
      contentContainerStyle={styles.scrollViewContainer}
    >
      <Show
        when={qstore.isReady(questionId)}
        fallback={<Loading />}
      >
        {answers?.map(answer => (
          <TherapistCard
            key={answer._id}
            title={getMetaValue('title', answer) || answer.wording || '?'}
            subtitle={'Counsellor'}
            picture={getMetaValue('picture', answer)}
            onPress={() => onPress(answer)}
          />
        ))}
      </Show>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scrollViewContainer: {
    display: 'flex',
    paddingVertical: SPACING['sp-8'],
    flexDirection: 'column',
    gap: SPACING['sp-16'],
    marginBottom: SPACING['sp-32']
  }
});

export const PresentCounsellors = observer(_PresentCounsellors);
